import {FC} from "react";
import {Card} from "react-bootstrap";
import {GuidePost} from "@oldDashboard/legacyModels/guidePost.model";
import { numberFormat } from "@oldDashboard/legacyUtils";

interface GuidePostProps {
    guidePost: GuidePost;
}
const GuidePostTile: FC<GuidePostProps> = (props) => {

    const { guidePost } = props;
    return (
        <Card className="custom-card">
            <div className="d-flex align-items-start mb-4 w-100">
                <video width="100%" className="rounded-top" controls={true} autoPlay={true} muted={true}>
                    <source
                        src={guidePost.media_url}
                        height="100%"
                        width="100%"
                        type="video/mp4"/>
                    Your browser does not support the video tag.
                </video>
            </div>
            <Card.Body className="pt-2 d-flex flex-column justify-content-end">
                <div>
                    <div className="mb-3">
                        <div>
                            <p className="mb-0 fs-18 fw-semibold">{guidePost.title}</p>
                        </div>
                    </div>
                    <div className="mb-3">
                        <div>
                            <p className="mb-0 fw-semibold">{guidePost.strategy}</p>
                            <p className="fs-12 text-muted mb-0">Strategy</p>
                        </div>
                    </div>
                    <div className="mb-3">
                        <div>
                            <p className="mb-0 fw-semibold">{guidePost.objective}</p>
                            <p className="fs-12 text-muted mb-0">Objective</p>
                        </div>
                    </div>
                </div>
                {  guidePost.engagements > 0 && 
                <div className="d-grid">
                    <div className="p-2 border border-primary rounded text-center">
                        <div>
                            <p className="mb-0 fs-16"><b>{numberFormat(guidePost.engagements)}</b></p>
                            <p className="fs-12 text-muted mb-0">Engagements</p>
                        </div>
                    </div>
                </div>
                }
                {  guidePost.impressions > 0 && 
                <div className="d-grid">
                    <div className="p-2 border border-primary rounded text-center">
                        <div>
                            <p className="mb-0 fs-16"><b>{numberFormat(guidePost.impressions)}</b></p>
                            <p className="fs-12 text-muted mb-0">Impressions</p>
                        </div>
                    </div>
                </div>
                }
            </Card.Body>
        </Card>
    );
};

export default GuidePostTile;